<template>
  <div class="main-container">
    <div>
      <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment-->
      <breadcrumb :list="breadcrumbList" />
      <tl-header type="h1">
        <div class="main-header">Voluntary PF</div>
      </tl-header>
      <div class="uploadMethoRadio">
        <tl-radio
          name="uploadType"
          label="Manual"
          id="manualUpload"
          value="manualUpload"
          v-model="uploadMethod"
        />

        <tl-radio
          name="uploadType"
          label="Bulk Upload"
          id="bulkUpload"
          value="bulkUpload"
          v-model="uploadMethod"
        />
      </div>

      <div v-if="uploadMethod == 'manualUpload'">
        <div class="searchclass">
          <search-dropdown
            label="Select Employee"
            :employeeData="employeeData"
            @empselected="(emp)=>selectedEmp(emp)"
          />
        </div>
        <div class="vpfCalcs">
          <br />
          <div class="emp-label">
            <b>VPF employee/s</b>
          </div>

          <div class="uploadMethoRadio">
            <tl-radio
              name="wageType"
              label="% of PF Wages"
              id="percentage"
              value="percentage"
              v-model="wageMethod"
            />
            <div class="midMargin"></div>
            <tl-radio
              name="wageType"
              label="Flat Amount"
              id="flat"
              value="flat"
              v-model="wageMethod"
            />
          </div>
          <div class="filters">
            <txt type="text" v-model="percentage" name="Percentage" />

            <txt type="text" v-model="flatAmount" name="FlatAmount" />
          </div>
          <br />
          <div class="filters">
            <tl-select
              label="Effective Month"
              :options="effMonthOptions"
              :value="effMonth"
              @change="(val)=>effMonth=val"
            ></tl-select>
          </div>
          <btn-grp class="top-margin-20">
            <btn text="Reset" type="secondary" class v-on:click="reset"></btn>
            <btn text="Submit" type="primary" class v-on:click="submit"></btn>
          </btn-grp>
        </div>

        <tl-header type="h1">
          <div class="main-header">Employee List</div>
        </tl-header>

        <div class="empList">
          <div class="emp-label">
            <b>VPF employee/s</b>
            <div class="smallRect">
              <b>15</b>
            </div>
          </div>
        </div>
        <div class="vpf-emp">
          <div class="filters">
            <tl-select
              label="Paygroups"
              :options="paygroupsOptions"
              :value="paygroups"
              @change="(val)=>paygroups=val"
            ></tl-select>

            <tl-select
              label="Department"
              :options="departmentOptions"
              :value="department"
              @change="(val)=>department=val"
            ></tl-select>

            <tl-select
              label="Location"
              :options="locationOptions"
              :value="location"
              @change="(val)=>location=val"
            ></tl-select>
          </div>
          <div class="filters top-margin-10">
            <tl-select
              label="Cost Centre"
              :options="costCenterOptions"
              :value="costCenter"
              @change="(val)=>costCenter=val"
            ></tl-select>

            <tl-select
              label="Designation"
              :options="designationOptions"
              :value="designation"
              @change="(val)=>designation=val"
            ></tl-select>
            <div />
            <div />
            <div />
            <!-- <button class="moreFiltersBtn" @click="moreFilters">
              <b> More Filters </b>
            </button>-->
            <!-- <div>
                <btn class="moreFiltersBtn" @click="moreFilters" text="More Filters">
                </btn>
            </div>-->

            <div class="text-right">
              <button class="filterbtn">
                <label class="more-filters">More Filters</label>
              </button>
            </div>
          </div>

          <div class></div>

          <div class="searchsort top-margin-20">
            <!-- <tl-search @change="filterData" /> -->
            <search-dropdown :employeeData="employeeData" @empselected="(emp)=>selectedEmp(emp)" />
            <div class="sorttext">
              <span>Sort By:</span>
            </div>&nbsp; &nbsp; &nbsp;
            <tl-select
              class="customwidth"
              :options="sortByOptions"
              :value="sortBy"
              @change="(val)=>sortBy=val"
            ></tl-select>
          </div>

          <!-- <search-dropdown :employeeData="employeeData" @empselected="(emp)=>selectedEmp(emp)" />
          <div class="sort-by">

            <span class="input-label"> Sort By: </span>
            <div class="sortByDropdown">
              <tl-select :options="sortByOptions" :value="sortBy" @change="(val)=>sortBy=val"></tl-select>
            </div>
          </div>-->
        </div>
        <!-- {{filteredEmployeesData}} -->
        <div class="top-margin-30">
          <data-table
            v-show="showDataTable"
            :columns="columnNames"
            :tableData="employeeData"
            :checkbox="false"
            :search="search"
            :with-form="false"
            :showedit="true"
            @editStart="showEditPopup"
            :showdelete="false"
            :showhistory="true"
            @history="showHistoryPopup"
          >
            <template v-slot:rowcontent="slotprops">
              <img
                class="imgClass"
                v-if="slotprops.value.column.key=='image'"
                :src="slotprops.value.record[slotprops.value.column.key]"
              />
            </template>
          </data-table>
        </div>

        <!-- modal for editing data table data -->
        <div class="modal" v-if="showPopup">
          <div class="modal-content">
            <div class="top-bar">
              <span class="heading_new">Edit VPF</span>
            </div>
            <div class="imagearea">
              <img src="`${editEmployeePopupDetails.image}`" />
              <div class="imagedetails">
                <p>{{editEmployeePopupDetails.name}}</p>
                <p class="empid">{{editEmployeePopupDetails.code}}</p>
                <span>{{editEmployeePopupDetails.EmailID}}</span>
              </div>
            </div>
            <div class="uploadMethoRadio">
              <tl-radio
                name="wageType"
                label="% of PF Wages"
                id="percentage"
                value="percentage"
                v-model="editEmployeePopupDetails.wageMethod"
              />
              <div class="midMargin"></div>
              <tl-radio
                name="wageType"
                label="Flat Amount"
                id="flat"
                value="flat"
                v-model="editEmployeePopupDetails.wageMethod"
              />
            </div>
            <div class="filters">
              <txt
                type="text"
                v-model="editEmployeePopupDetails.percentageOfPFWages"
                name="Percentage"
              />
              <txt type="text" v-model="editEmployeePopupDetails.flatAmount" name="FlatAmount" />
            </div>
            <br />
            <div class="filters">
              <tl-select
                label="Effective Month"
                :options="effMonthOptions"
                :value="editEmployeePopupDetails.effectiveMonth"
                @change="(val)=>editEmployeePopupDetails.effectiveMonth=val"
              ></tl-select>
            </div>
            <btn-grp class="modal-btnGrp">
              <btn text="Cancel" type="secondary" class v-on:click="cancelEdit"></btn>
              <btn text="Save" type="primary" class v-on:click="saveEdit"></btn>
            </btn-grp>
          </div>
        </div>

        <!-- modal for showing data table history -->
        <div class="modal" v-if="showPopupHistory">
          <div class="modal-content-history">
            <div class="top-bar">
              <span class="heading_new">VPF History</span>
            </div>
            <div class="imagearea">
              <img src="@/assets/user.svg" />
              <div class="imagedetails">
                <p>{{ historyData.name }}</p>
                <p class="empid">{{ historyData.code }}</p>
                <span>{{ historyData.email }}</span>
              </div>
            </div>
            <div class="datatableClass">
              <data-table
                :columns="historyDataCols"
                :tableData="historyTableData"
                :checkbox="false"
                :search="search"
                :showedit="false"
                :showdelete="false"
                :showhistory="false"
              ></data-table>
            </div>
            <br />
            <button class="btn-popup" type="button" @click="backToVPF">Back to VPF</button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="download-btn">
          <download-button></download-button>
        </div>
        <div class="upload">
          <p></p>
          <p>Drag & drop files here</p>
          <p>Or</p>
          <div class="upload-button">
            <img src="@/assets/logout-copy-2_2@2x.png" alt />
            <label for="upload-photo">Browse</label>
            <input type="file" name="photo" id="upload-photo" />
          </div>
        </div>
        <br />
        <btn text="Submit" type="primary" class v-on:click="submitBulk"></btn>
      </div>

      <pop-up-message
        v-if="showSuccessMsg"
        :message="`VPF added for ${empName}.`"
        btnText="Back To VPF"
        @back="backToVPF"
      ></pop-up-message>
    </div>
    <!-- <bottom-action-container> -->
    <div class="bottom-line" />
    <btn-grp slot="end" class="btnGrpClass">
      <btn text="Back" type="secondary" class v-on:click="back"></btn>
    </btn-grp>
    <!-- </bottom-action-container> -->
  </div>
</template>


<script>
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";

export default {
  name: "AddExitEmployees",
  components: {
    SelectedEmployeeCard,
    SearchDropdown
  },
  data() {
    return {
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },
        {
          name: "Voluntary PF",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/voluntaryPf`
        }
      ],
      empCN: "abc123",
      empName: "",
      paygroups: "All",
      department: "All",
      location: "All",
      costCenter: "All",
      designation: "All",
      vpfId: "",
      sortBy: "",
      wageMethod: "percentage",
      search: "",
      uploadMethod: "manualUpload",
      percentage: "",
      flatAmount: "",
      effMonth: "April",
      effMonthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      showSuccessMsg: false,
      showPopup: false,
      showPopupHistory: false,
      editEmployeePopupDetails: {},
      paygroupsOptions: [],
      departmentOptions: [],
      designationOptions: [],
      costCenterOptions: [],
      locationOptions: [],
      sortByOptions: [],
      historyDataCols: [
        {
          label: "% of PF Wage",
          key: "percentage"
        },
        {
          label: "Flat Amount",
          key: "flatAmount"
        },
        {
          label: "Effective Month",
          key: "effMonth"
        }
      ],
      historyTableData: [],
      historyData: {},
      dropdownData: [
        {
          id: 0,
          value: "Cessation"
        },
        {
          id: 1,
          value: "Resigned"
        },
        {
          id: 2,
          value: "Termination"
        },
        {
          id: 3,
          value: "Death in service"
        },
        {
          id: 4,
          value: "Permanent disability"
        },
        {
          id: 5,
          value: "Retirement"
        },
        {
          id: 6,
          value: "Superannuation"
        }
      ],
      le_id: "379a50dc-5696-40d8-b7e6-ca2dc0b68d4a",
      loid: "3c34887d-da90-4078-baca-be4e343d26b8",
      columnNames: [
        {
          label: "",
          key: "image"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "EmailID",
          key: "EmailID"
        },
        {
          label: "Location",
          key: "Location"
        },
        {
          label: "% of PF Wages",
          key: "percentageOfPFWages"
        },
        {
          label: "Flat Amount",
          key: "flatAmount"
        }
      ],
      employeeData: [
        // {
        //   image: require('@/assets/user.svg'),
        //   code: "RC1234",
        //   name: "Roxie Schmidt",
        //   department: "IT",
        //   EmailID: "Roxie.Schmidt@gmail.com",
        //   Location: "South Sigmund",
        //   percentageOfPFWages: "5%",
        //   flatAmount: "Rs 2000",
        //   effectiveMonth: "April"
        // },
        // {
        //   image: require('@/assets/user.svg'),
        //   code: "RC1234",
        //   name: "Roxie Schmidt",
        //   department: "IT",
        //   EmailID: "Roxie.Schmidt@gmail.com",
        //   Location: "South Sigmund",
        //   percentageOfPFWages: "5%",
        //   flatAmount: "Rs 2000",
        //   effectiveMonth: "April"
        // },
        // {
        //   image: require('@/assets/user.svg'),
        //   code: "RC1234",
        //   name: "Roxie Schmidt",
        //   department: "IT",
        //   EmailID: "Roxie.Schmidt@gmail.com",
        //   Location: "South Sigmund",
        //   percentageOfPFWages: "5%",
        //   flatAmount: "Rs 2000",
        //   effectiveMonth: "April"
        // },
        // {
        //   image: require('@/assets/user.svg'),
        //   code: "RC1234",
        //   name: "Roxie Schmidt",
        //   department: "IT",
        //   EmailID: "Roxie.Schmidt@gmail.com",
        //   Location: "South Sigmund",
        //   percentageOfPFWages: "5%",
        //   flatAmount: "Rs 2000",
        //   effectiveMonth: "April"
        // }
      ],
      auto_suggestions: false,
      filterEmpData: [],
      employeeSearchData: [
        {
          src: "@/assets/user.svg",
          name: "Chetna Garg",
          code: "4589",
          email: "C@gmail.com",
          role: "Developer"
        },
        {
          src: "@/assets/user.svg",
          name: "Chetna Garg",
          code: "4589",
          email: "C@gmail.com",
          role: "Developer"
        },
        {
          src: "@/assets/user.svg",
          name: "Chetna Garg",
          code: "4589",
          email: "C@gmail.com",
          role: "Developer"
        },
        {
          src: "@/assets/user.svg",
          name: "Chetna Garg",
          code: "4589",
          email: "C@gmail.com",
          role: "Developer"
        },
        {
          src: "@/assets/user.svg",
          name: "Chetna Garg",
          code: "4589",
          email: "C@gmail.com",
          role: "Developer"
        },
        {
          src: "@/assets/user.svg",
          name: "Chetna Garg",
          code: "4589",
          email: "C@gmail.com",
          role: "Developer"
        }
      ],
      showDataTable: false
    };
  },
  activated() {
    // this.fetchJoinings()// fetch all employees
    this.moreFilters();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      getlocid: "onboard/locations/getData"
    }),
    ...mapState({
      filteredEmployeesData: state =>
        state.dashboard.organisation.utilities.voluntaryPf.voluntaryPfEmployee,
      employeesJoiningsData: state => state.payroll.joinings.joinings //fetch all employees data
    })
    // le_id() {
    //   if (this.$route.params.entity_index)
    //     return this.getleid(this.$route.params.entity_index);
    //   else return this.getleid(0);
    // },
    // loid() {
    //   if (this.$route.params.entity_index)
    //     return this.getlocid(this.$route.params.entity_index);
    //   else return this.getlocid(0);
    // }
  },
  methods: {
    ...mapActions({
      act_fetchAll:
        "dashboard/organisation/utilities/voluntaryPf/fetchVoluntaryPfEmployees",
      act_create: "dashboard/organisation/utilities/voluntaryPf/create",
      act_fetchHistory:
        "dashboard/organisation/utilities/voluntaryPfHistory/fetchVoluntaryPfEmployeesHistory",
      act_update: "dashboard/organisation/utilities/voluntaryPf/update"
      // act_fetchJoinings: "payroll/joinings/fetchJoinings",
    }),
    filterData(searchText) {
      this.search = searchText;
    },
    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    backToVPF() {
      this.showSuccessMsg = false;
      this.showPopupHistory = false;
    },
    async saveEdit() {
      this.showPopup = false;

      try {
        this.$root._data.isSaving = true;
        let obj = {
          id: this.vpfId,
          empId: "d18f1fc1-c7f0-4dba-a34e-9da68c534a63",
          empName: "thrymr12",
          pfWages: this.editEmployeePopupDetails.percentageOfPFWages,
          flatAmount: this.editEmployeePopupDetails.flatAmount,
          month: this.editEmployeePopupDetails.effectiveMonth
        };
        //console.log("updated data", obj);
        let res = await this.act_update(obj);
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err.message;
        //console.log("error", err);
      }
    },
    cancelEdit() {
      this.showPopup = false;
    },

    async moreFilters() {
      this.showDataTable = true;
      try {
        let obj = {
          loid: "3c34887d-da90-4078-baca-be4e343d26b8",
          pgid: "a8958372-241a-46ec-950e-21d129ec2222",
          ccid: "3c34887d-da90-4078-baca-be4e343d26b8",
          designationid: "5ff8c5a5-0122-4ea7-844a-e79a6f965c23"
          // departmentid: "", should be filled dynamically
        };

        let res = await this.act_fetchAll(obj);
        //console.log("employee dta", this.filteredEmployeesData);
        for (var i = 0; i <= this.filteredEmployeesData.length; i++) {
          let obj = {};
          obj.image = "@/assets/user.svg";
          obj.code = this.filteredEmployeesData[i].empId;
          obj.name = this.filteredEmployeesData[i].Employee.fullname;
          obj.department = "IT";
          obj.EmailID = this.filteredEmployeesData[i].Employee.offiEmailId;
          obj.Location = "South Sigmund";
          obj.percentageOfPFWages = this.filteredEmployeesData[i].pfWages;
          obj.flatAmount = this.filteredEmployeesData[i].FlatAmount;
          obj.effectiveMonth = this.filteredEmployeesData[i].month;
          this.vpfId = this.filteredEmployeesData[i].id;
          this.employeeData.push(obj);
        }
        // if(res.message != null){
        //   throw Error(res.message);
        // }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
        //console.log("error", err);
      }
    },
    //  async fetchJoinings() { should fetch all employees
    //     try {
    //         let res = await this.act_fetchJoinings(this.paygroupId);
    //         //console.log('fetched joinings data', res)
    //         if(res.message != null){
    //         throw Error(res.message);
    //         }
    //     }
    //     catch(err) {
    //         this.toast = true;
    //         this.errmsg = err.message;
    //     }
    // },
    substep(val) {
      //console.log("sub step name", val);
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    mainstep(val) {
      //console.log("main step name", val);
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation`
      });
    },
    reset() {
      this.percentage = "";
      this.flatAmount = "";
      this.effMonth = "";
    },
    showEditPopup(record) {
      //console.log("popup record", record);
      this.showPopup = true;
      this.editEmployeePopupDetails = record;
      if (record.flatAmount) {
        this.editEmployeePopupDetails.wageMethod = "flatAmount";
      } else {
        this.editEmployeePopupDetails.wageMethod = "percentage";
      }
    },
    async showHistoryPopup(record) {
      //console.log("popup history record", record);
      this.showPopupHistory = true;
      try {
        let empId = "d18f1fc1-c7f0-4dba-a34e-9da68c534a63";
        let obj = {};
        let res = await this.act_fetchHistory(empId);
        for (var i = 0; i <= res.data.rows.length; i++) {
          this.historyData.name = res.data.rows[i].Employee.fullname;
          this.historyData.code = res.data.rows[i].empId;
          this.historyData.email = res.data.rows[i].Employee.offiEmailId;

          //console.log("emp ghistory details", this.historyData);

          obj.percentage = res.data.rows[i].pfWages;
          obj.flatAmount = res.data.rows[i].flatAmount;
          obj.effMonth = res.data.rows[i].month;

          this.historyTableData.push(obj);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
        //console.log("error", err);
      }
    },
    async submit() {
      // this.$validator.validatleteAll().then(result => {
      // if (result) {
      this.performAction();
      this.showSuccessMsg = true;
      // }
      // });
    },
    async performAction() {
      // //console.log('joinings data', this.employeesJoiningsData)
      this.$root._data.isSaving = true;
      //console.log("inside");
      let obj = {
        empId: "d18f1fc1-c7f0-4dba-a34e-9da68c534a63",
        empName: "thrymr12",
        pfWages: this.percentage,
        flatAmount: this.flatAmount,
        month: this.effMonth
      };
      await this.act_create(obj);
      this.reset();
      setTimeout(() => {
        this.$root._data.isSaving = false;
      }, 500);
    },
    searchData(key, array) {
      const final = [];
      for (let i = 0; i < array.length; i++) {
        let searchObj = array[i].name;
        if (
          searchObj != null &&
          searchObj.toLowerCase().search(key.toLowerCase()) !== -1
        ) {
          final.push(array[i]);
        }
      }
      return final;
    },

    filterData(searchText) {
      let data = this.$_.cloneDeep(this.employeeSearchData);
      if (searchText.length) {
        this.auto_suggestions = true;
        this.filterEmpData = this.searchData(
          searchText,
          this.employeeSearchData
        );
      } else {
        this.auto_suggestions = false;
      }
    },
    selectedEmp(emp) {
      //console.log("emp sleected data", emp);
      this.empName = emp.name;
      this.empId = emp.code;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.filterbtn {
  width: 60%;
  height: 65%;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  grid-column: -1/ -2;
  align-self: center;
  padding: 8px;
  margin-bottom: 3px;
  margin-top: 10px;
}

.text-right {
  text-align: center;
}

.more-filters {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  color: #34c0be;
}

.top-margin-10 {
  margin-top: 10px;
}

.top-margin-20 {
  margin-top: 20px;
}

.top-margin-30 {
  margin-top: 30px;
}

.emp-label {
  opacity: 0.5;
  font-family: Montserrat;
  font-size: 14px;
  color: #000000;
  display: flex;
  margin-bottom: 1%;
}

.smallRect {
  margin-left: 10px;
  width: 29px;
  height: 21px;
  border-radius: 4px;
  text-align: center;
  color: #5d409f;
  font-size: 12px;
  background-color: #f2f3f3;
}

.content {
  margin-left: 20px;
  margin-top: 15px;
}

.sort-by {
  display: flex;
  float: right;
}

.sortByDropdown {
  width: 15%;
}

.moreFiltersBtn {
  width: 95px;
  height: 35px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  font-size: 12px;
  font-family: Montserrat;
  margin-top: 10%;
  margin-left: 44%;
  cursor: pointer;
}

.midMargin {
  margin-left: 4.5%;
}

.subtitle {
  width: 316px;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #646464;
}

.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}

.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}

.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;
}

.bottom-line {
  border-bottom: 1px solid #34c0be;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 15%;
}

.searchclass {
  width: 30%;
}

.btnGrpClass {
  float: right;
}

.imgClass {
  width: 60px;
  height: 60px;
}

.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}

.download-btn {
  margin-top: 2%;
}

.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      lightgray 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}

.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}

.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

/* Modal Content */

.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 0px;

  .uploadMethoRadio,
  .filters {
    margin-left: 8%;
    margin-top: 2%;

    .midMargin {
      margin-left: 11.5%;
    }
  }
  .modal-btnGrp {
    justify-content: center;
  }
}

.modal-content-history {
  background-color: white;
  margin: 60px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 510px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 0px;

  .datatableClass {
    margin-left: 10%;
    margin-top: 5%;
    overflow-y: scroll;
  }
}

.top-bar {
  background-color: #34c0be;
  display: flex;
  width: 108%;
  margin-top: -30px;
}

.heading_new {
  font-family: Montserrat;
  font-size: 22px;
  font-weight: bold;
  padding: 10px;
  color: #ffffff;
}

.imagearea {
  display: flex;

  img {
    padding: 10px;
    margin-left: 5%;
    width: 90px;
    height: 90px;
  }
}

.imagedetails {
  padding: 10px;
  color: #646464;
  font-size: 16px;
  font-family: Montserrat;
  margin-top: 1%;

  span {
    font-size: 14px;
    margin-bottom: 3px;
    color: #878787;
  }
  p {
    margin-bottom: 0px;
  }
  .empid {
    margin-top: 3px;
    font-size: 14px;
    color: #878787;
  }
}

.btn-popup {
  display: block;
  border-radius: 4px;
  height: 35px;
  width: 120px;
  align-self: center;
  background-color: $color-primary;
  color: $color-white;
}

.searchsort {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  .sorttext {
    text-align: center;
    line-height: 30px;
    color: #726f75;
    padding: 0px 0px 0px 10px;
    margin-left: auto;
  }
}

.customwidth {
  width: 100%;
  height: 35px;
  max-width: 200px;
  margin-top: -8px;
}
</style>
